module.exports = __webpack_public_path__ + "c16cc2394b95dcadf36b07ac2e6e2965.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_14.jpg
 ** module id = 596
 ** module chunks = 0
 **/